import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const QRCodeText = styled.span<React.CSSProperties>`
  color: ${Colors['dark']};
  font-size: ${Screen.widthRatio * 118}px;
  margin-left: ${Screen.widthRatio * 115}px;
  position: relative;
  top: ${Screen.widthRatio * -67}px;
  font-family: ${Fonts['light']};
`;

export default QRCodeText;
